/*
  assets/cart-upsell.js – Hennashoppe cart drawer upsells
  Load in layout/theme.liquid just before </body>:
    <script src="{{ 'cart-upsell.js' | asset_url }}" defer></script>
*/
(function () {
  'use strict';

  const CONFIG = {
    sectionId: 'cart-upsell',          // matches sections/cart-upsell.liquid
    mountSelector: '[data-cart-upsell]', // put <div data-cart-upsell></div> in the drawer
    maxVisible: 8,                     // how many upsells go in the slider
    useShopifyRecsFallback: true,      // fall back to Shopify's automatic "related" products

    // After a customer adds an upsell, the drawer refreshes itself automatically.
    // Optional manual override, only needed if the automatic refresh fails:
    cartSectionIds: [],                // e.g. ['header']
    refreshSelectors: [],              // e.g. ['.cart--body']
    // Header cart-count bubbles to update with the new item count
    countSelectors: ['[data-cart-count]', '.cart-count', '.cart--count', '[data-item="cart-count"]', '.header--cart-count'],
    reloadAsLastResort: true,          // reload only if nothing else worked (drawer re-opens after)
    // The header cart icon(s) that open the drawer, tried in this order
    drawerOpenSelectors: ['.header--cart-toggle', 'a[data-drawer-view="cart-drawer"]', '[data-drawer-open="cart"]', '[data-drawer-toggle="cart"]', '[data-drawer-open*="cart"]',
                          '[data-drawer-toggle*="cart"]', '[data-cart-toggle]', '[aria-controls*="cart"]',
                          'header a[href$="/cart"]', 'a[href$="/cart"]'],
    debug: false                         // logs each step in the browser console (F12). Set false when it works.
  };

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const CART_URL_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  const nativeFetch = window.fetch.bind(window);
  const log = function () { if (CONFIG.debug) console.log.apply(console, ['[cart-upsell]'].concat([].slice.call(arguments))); };
  const themeCartUrls = []; // HTML requests the theme itself makes to draw the cart

  let lastKey = null;
  let cachedHTML = '';
  let timer = null;

  // Re-checks arrow state whenever the slider changes size (e.g. when the drawer opens)
  const sliderObserver = 'ResizeObserver' in window
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (en) { updateArrows(en.target.closest('.cart-upsell')); });
      })
    : null;

  // ---------- helpers ----------
  async function getCart() {
    const r = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function getText(url) {
    try {
      const r = await nativeFetch(url);
      return r.ok ? r.text() : '';
    } catch (e) { return ''; }
  }

  // Parse the section HTML, drop products already in the cart, keep N.
  function buildUpsell(html, inCart) {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const box = doc.querySelector('.cart-upsell');
    if (!box) return null;

    const items = box.querySelectorAll('.cart-upsell__item');
    let kept = 0;
    items.forEach(function (el) {
      if (inCart.has(el.dataset.productId) || kept >= CONFIG.maxVisible) el.remove();
      else kept++;
    });
    if (!kept) return null;

    // keep the <style> block from the section with the markup
    const style = doc.querySelector('style');
    return (style ? style.outerHTML : '') + box.outerHTML;
  }

  function fillMounts(html) {
    document.querySelectorAll(CONFIG.mountSelector).forEach(function (m) {
      m.innerHTML = html;
      m.setAttribute('data-cu-filled', '');
      const list = m.querySelector('.cart-upsell__list');
      if (list) {
        if (sliderObserver) sliderObserver.observe(list);
        updateArrows(m.querySelector('.cart-upsell'));
      }
    });
  }

  // ---------- main ----------
  async function refresh(force) {
    if (!document.querySelector(CONFIG.mountSelector)) return;

    const cart = await getCart();
    if (!cart.items || !cart.items.length) {
      lastKey = null; cachedHTML = '';
      fillMounts('');
      return;
    }

    // Shopify lists the most recently added line item first.
    const anchor = cart.items[0];
    const inCart = new Set(cart.items.map(function (i) { return String(i.product_id); }));
    const key = anchor.product_id + '|' + Array.from(inCart).sort().join(',');
    if (!force && key === lastKey) { fillMounts(cachedHTML); return; }
    lastKey = key;

    // 1) hand-picked metafield or same-category collection
    let html = buildUpsell(
      await getText(root + 'products/' + anchor.handle + '?section_id=' + CONFIG.sectionId),
      inCart
    );

    // 2) Shopify's automatic related products
    if (!html && CONFIG.useShopifyRecsFallback) {
      html = buildUpsell(
        await getText(root + 'recommendations/products?product_id=' + anchor.product_id +
          '&limit=10&intent=related&section_id=' + CONFIG.sectionId),
        inCart
      );
    }

    cachedHTML = html || '';
    fillMounts(cachedHTML);
  }

  function schedule(force) {
    clearTimeout(timer);
    timer = setTimeout(function () { refresh(force); }, 300);
  }

  // ---------- refresh the theme's drawer after an upsell is added ----------
  const wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  // The element in the drawer that holds the line items (the cart form in Blockshop)
  const LINE_ITEM_SEL = 'input[name^="updates"], input[type="number"], [href*="/cart/change"], [data-item*="quantity"], [name="quantity"]';

  function hasLineItems(el) {
    return Array.prototype.some.call(el.querySelectorAll(LINE_ITEM_SEL), function (n) { return !n.closest('.cart-upsell'); });
  }

  // The smallest element around our slider that also contains the cart's line items
  function drawerRoot() {
    const m = document.querySelector(CONFIG.mountSelector + '[data-cu-filled]') ||
              document.querySelector(CONFIG.mountSelector);
    if (!m) return null;
    for (let el = m.parentElement; el && el !== document.body; el = el.parentElement) {
      if (hasLineItems(el)) return el;
    }
    return m.closest('form') || m.parentElement;
  }

  // Does the drawer (ignoring our upsell slider) list this product yet?
  function drawerShows(title, variantId) {
    const r = drawerRoot();
    if (!r || (!title && !variantId)) return false;
    const clone = r.cloneNode(true);
    clone.querySelectorAll('.cart-upsell').forEach(function (n) { n.remove(); });
    if (variantId && clone.innerHTML.indexOf(String(variantId)) !== -1) return true;
    return !!title && clone.textContent.toLowerCase().indexOf(title.toLowerCase()) !== -1;
  }

  // Finds the same element in a freshly fetched copy of the page
  function findTwin(el, doc) {
    if (el.id && doc.getElementById(el.id)) return doc.getElementById(el.id);
    // ignore classes this script adds (e.g. cart-upsell--refreshing), they never exist in fresh HTML
    const classes = Array.from(el.classList).filter(function (c) { return c.indexOf('cart-upsell') !== 0; });
    const tag = el.tagName.toLowerCase();
    const candidates = [];
    if (classes.length) candidates.push(tag + '.' + classes.map(function (c) { return CSS.escape(c); }).join('.'));
    if (el.getAttribute('action')) candidates.push(tag + '[action="' + el.getAttribute('action') + '"]');
    candidates.push('form.cart--form', 'form[action$="/cart"]');   // Blockshop's cart form
    for (const sel of candidates) {
      const found = doc.querySelector(sel);
      if (found) { log('matched fresh drawer with', sel); return found; }
    }
    // Some views return only the inside of the form: use the whole response if it has cart items
    if (hasLineItems(doc.body)) { log('using whole response as drawer content'); return doc.body; }
    return null;
  }

  // Strategy: fetch fresh cart HTML in the background and copy it into the open drawer.
  // Tries the URLs the theme itself used for the cart, then this page, then /cart.
  async function swapFromPage(title, variantId) {
    const r = drawerRoot();
    if (!r) { log('no drawer root found'); return false; }
    log('drawer root:', r);
    const urls = [root + 'cart?view=ajax-drawer'].concat(themeCartUrls);
    const seen = {};
    for (const url of urls) {
      if (seen[url]) continue;
      seen[url] = true;
      try {
        const t = performance.now();
        const res = await nativeFetch(url, { credentials: 'same-origin', cache: 'no-store' });
        log('fetched', url, 'in', Math.round(performance.now() - t), 'ms');
        if (!res.ok) { log('fetch failed', url, res.status); continue; }
        let html = await res.text();
        if (html.trim().charAt(0) === '{') {               // ?sections= JSON response
          const json = JSON.parse(html);
          html = Object.keys(json).map(function (k) { return json[k] || ''; }).join('');
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = findTwin(r, doc);
        if (!fresh) { log('drawer not found in', url); continue; }
        const freshText = fresh.innerHTML;
        const hasNew = (variantId && freshText.indexOf(String(variantId)) !== -1) ||
                       (title && fresh.textContent.toLowerCase().indexOf(title.toLowerCase()) !== -1);
        if (!hasNew) { log('fresh copy from', url, 'does not contain the new product'); continue; }
        r.innerHTML = freshText;
        log('drawer refreshed from', url);
        return true;
      } catch (e) { log('error with', url, e); }
    }
    return false;
  }

  // If we ever do have to reload, open the cart drawer again afterwards
  const REOPEN_KEY = 'cart-upsell-reopen';
  function reopenDrawerAfterReload() {
    let flag = null;
    try { flag = sessionStorage.getItem(REOPEN_KEY); sessionStorage.removeItem(REOPEN_KEY); } catch (e) {}
    if (!flag) return;
    let tries = 0;
    const attempt = function () {
      const trigger = cartToggle();
      log('reopen drawer via', trigger);
      if (trigger) trigger.click();
      else if (++tries < 5) setTimeout(attempt, 500);
    };
    let started = false;
    const start = function () { if (!started) { started = true; setTimeout(attempt, 300); } };
    window.addEventListener('theme:loaded', start);          // Blockshop is ready
    if (document.readyState === 'complete') setTimeout(start, 1500);
    else window.addEventListener('load', function () { setTimeout(start, 1500); });
  }

  async function waitFor(check, ms) {
    for (let t = 0; t < ms; t += 200) {
      if (check()) return true;
      await wait(200);
    }
    return check();
  }

  // Strategy 1: ask Blockshop to refresh itself by "touching" an existing quantity box.
  // The quantity stays the same; the theme fetches the cart and redraws the drawer with its own code.
  function nudgeTheme() {
    const r = drawerRoot();
    if (!r) return false;
    const qty = r.querySelector('input[name="updates[]"], input[name^="updates"], input[name="quantity"], input[type="number"]');
    if (!qty) return false;
    qty.dispatchEvent(new Event('input', { bubbles: true }));
    qty.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  // Strategy 2: re-render the drawer's section with Shopify's Section Rendering API
  async function swapSection() {
    const r = drawerRoot();
    const sec = r && r.closest('.shopify-section');
    if (!sec || !sec.id) return false;
    const sid = sec.id.replace(/^shopify-section-/, '');
    const res = await nativeFetch(window.location.pathname + '?sections=' + encodeURIComponent(sid));
    if (!res.ok) return false;
    const json = await res.json();
    if (!json[sid]) return false;
    const doc = new DOMParser().parseFromString(json[sid], 'text/html');
    let fresh = r.id ? doc.getElementById(r.id) : null;
    if (!fresh) {
      const idx = Array.prototype.indexOf.call(sec.querySelectorAll(r.tagName), r);
      fresh = doc.querySelectorAll(r.tagName)[idx];
    }
    if (!fresh) return false;
    r.innerHTML = fresh.innerHTML;
    return true;
  }

  // Manual override from CONFIG (only if filled in)
  function manualRefresh(addResponse) {
    const sections = addResponse && addResponse.sections;
    let done = false;
    if (sections && CONFIG.refreshSelectors.length) {
      Object.keys(sections).forEach(function (id) {
        if (!sections[id]) return;
        const doc = new DOMParser().parseFromString(sections[id], 'text/html');
        CONFIG.refreshSelectors.forEach(function (sel) {
          const fresh = doc.querySelector(sel);
          const current = document.querySelector(sel);
          if (fresh && current) { current.innerHTML = fresh.innerHTML; done = true; }
        });
      });
    }
    return done;
  }

  function updateCounts(count) {
    document.querySelectorAll(CONFIG.countSelectors.join(',')).forEach(function (el) {
      if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', count); // Blockshop header icon
      if (/\d/.test(el.textContent)) el.textContent = el.textContent.replace(/\d+/, count);
    });
  }

  // ---------- Blockshop (Troop Themes) integration ----------
  // Blockshop fires these on window: theme:cart:updated after it redraws the cart,
  // and theme:drawer:right:opened / closed for the cart drawer.
  let themeCartUpdatedAt = 0;
  let rightDrawerOpen = false;
  window.addEventListener('theme:cart:updated', function () { themeCartUpdatedAt = Date.now(); log('theme:cart:updated'); schedule(false); });
  window.addEventListener('theme:drawer:right:opened', function () { rightDrawerOpen = true; });
  window.addEventListener('theme:drawer:right:closed', function () { rightDrawerOpen = false; });

  function cartToggle() {
    for (const sel of CONFIG.drawerOpenSelectors) {
      const el = document.querySelector(sel);
      if (el) return el;
    }
    return null;
  }


  async function refreshThemeCart(addResponse) {
    const added = addResponse && addResponse.items && addResponse.items[0];
    const title = added ? added.product_title : '';
    const variantId = added ? added.variant_id : null;

    const form = drawerRoot();
    if (form) form.classList.add('cart-upsell--refreshing');

    let ok = manualRefresh(addResponse);

    // Blockshop draws its drawer from /cart?view=ajax-drawer: fetch it and swap it in
    if (!ok) {
      try { ok = await swapFromPage(title, variantId); } catch (e) { ok = false; }
    }

    const fresh = drawerRoot();
    if (form) form.classList.remove('cart-upsell--refreshing');
    if (fresh) fresh.classList.remove('cart-upsell--refreshing');
    log('refresh result:', ok ? 'updated in place' : 'falling back to reload');
    if (!ok && CONFIG.reloadAsLastResort) {
      try { sessionStorage.setItem(REOPEN_KEY, '1'); } catch (e) {}
      window.location.reload();
      return;
    }

    try {
      const cart = await getCart();
      updateCounts(cart.item_count);
      window.dispatchEvent(new CustomEvent('cart-upsell:drawer-refreshed', { detail: cart }));
    } catch (e) {}
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation(); // stop the drawer from treating this as an outside click

    const item = btn.closest('.cart-upsell__item');
    const idField = item.querySelector('[name="id"]');
    const errorEl = item.querySelector('.cart-upsell__error');
    const label = btn.textContent;

    btn.disabled = true;
    btn.textContent = 'Adding…';
    if (errorEl) errorEl.hidden = true;

    try {
      const body = { items: [{ id: Number(idField.value), quantity: 1 }] };
      if (CONFIG.cartSectionIds.length) body.sections = CONFIG.cartSectionIds.join(',');

      const t0 = performance.now();
      const res = await nativeFetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added.');

      log('cart/add.js took', Math.round(performance.now() - t0), 'ms');
      btn.textContent = 'Added';
      await Promise.all([refreshThemeCart(data), refresh(true)]);
      log('total time', Math.round(performance.now() - t0), 'ms');
    } catch (err) {
      btn.disabled = false;
      btn.textContent = label;
      if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
    }
  }, true);

  // ---------- slider arrows ----------
  function updateArrows(box) {
    if (!box) return;
    const list = box.querySelector('.cart-upsell__list');
    const prev = box.querySelector('[data-upsell-prev]');
    const next = box.querySelector('[data-upsell-next]');
    const arrows = box.querySelector('.cart-upsell__arrows');
    if (!list || !prev || !next) return;
    if (!list.clientWidth) return; // drawer is closed; ResizeObserver re-runs this on open
    const max = list.scrollWidth - list.clientWidth - 2;
    prev.disabled = list.scrollLeft <= 2;
    next.disabled = list.scrollLeft >= max;
    if (arrows) arrows.hidden = max <= 0; // everything fits, no arrows needed
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-upsell-prev], [data-upsell-next]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const list = btn.closest('.cart-upsell').querySelector('.cart-upsell__list');
    const card = list.querySelector('.cart-upsell__item');
    const step = card ? card.getBoundingClientRect().width + 12 : list.clientWidth;
    list.scrollBy({ left: btn.hasAttribute('data-upsell-next') ? step : -step, behavior: 'smooth' });
  }, true);

  // scroll events don't bubble, so listen in the capture phase
  document.addEventListener('scroll', function (e) {
    const t = e.target;
    if (t && t.classList && t.classList.contains('cart-upsell__list')) updateArrows(t.closest('.cart-upsell'));
  }, true);

  // ---------- watch for the theme's own cart changes ----------
  function rememberCartUrl(url) {
    if (!url || /cart\.js|recommendations|section_id=cart-upsell|\.json/.test(url)) return;
    if (!/cart|section/i.test(url)) return;
    try { if (new URL(url, location.href).origin !== location.origin) return; } catch (e) { return; }
    if (themeCartUrls.indexOf(url) === -1) { themeCartUrls.unshift(url); log('theme cart URL seen:', url); }
  }

  window.fetch = function () {
    const args = arguments;
    const p = nativeFetch.apply(window, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      if (CART_URL_RE.test(url)) p.then(function () { schedule(false); }).catch(function () {});
      else rememberCartUrl(url);
    } catch (e) {}
    return p;
  };

  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cuUrl = url;
    if (!CART_URL_RE.test(String(url || ''))) rememberCartUrl(String(url || ''));
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (CART_URL_RE.test(this._cuUrl || '')) this.addEventListener('loadend', function () { schedule(false); });
    return xhrSend.apply(this, arguments);
  };

  // If the theme re-renders the drawer, our mount comes back empty: refill from cache.
  new MutationObserver(function () {
    document.querySelectorAll(CONFIG.mountSelector + ':not([data-cu-filled])').forEach(function () {
      if (lastKey) fillMounts(cachedHTML); else schedule(false);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  reopenDrawerAfterReload();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { refresh(true); });
  else refresh(true);
})();
